export const MuiAutocompleteChangeReasons = {
  // For reference: https://material-ui.com/api/autocomplete/
  CREATE_OPTION: 'create-option',
  SELECT_OPTION: 'select-option',
  REMOVE_OPTION: 'remove-option',
  BLUR: 'blur',
  CLEAR: 'clear'
};

export const ImgixDimensions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
